<template>
    <div class="w-full">
        <ds-table :max-items="data.length" :data="data" :heads="heads" spacer :paginate="false">
            <template v-slot:domain="{domain}">
                <div class="flex items-center">
                    <vs-button radius color="primary" target :href="`https://${domain}`" type="flat" v-bind="$iconData('icon-eye', 'fi-rr-eye')"></vs-button>
                    <div class="ml-2">{{domain}}</div>
                </div>
            </template>
        </ds-table>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array
        }
    },

    data() {
        return {
            heads: [
                {name: 'global.Domain', value: 'domain', display: true},
            ]
        }
    }
}
</script>
